import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { ConfirmDialogComponent, ConfirmDialogSettings } from '../../ui/confirm-dialog/confirm-dialog.component';
import { getUserHomePage } from '../utils';
import { RouteHistoryService } from './route-history.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class GuardUtilsService {
  private userService = inject(UserService);
  private matDialog = inject(MatDialog);
  private routeHistoryService = inject(RouteHistoryService);
  private router = inject(Router);

  handleNoAccess(dialogTitle: string, dialogContent: string): void {
    this.matDialog.open<ConfirmDialogComponent, ConfirmDialogSettings>(ConfirmDialogComponent, {
      data: {
        title: dialogTitle,
        content: dialogContent,
        cancelButtonText: 'Close',
        hideConfirmButton: true,
      },
    });
    this.navigateToHomePageIfRequired();
  }

  private navigateToHomePageIfRequired(): void {
    const isEmptyRoutingHistoryState =
      !this.routeHistoryService.currentUrl.getValue() && !this.routeHistoryService.previousUrl.getValue();

    if (isEmptyRoutingHistoryState) {
      const user = this.userService.getUser();
      this.router.navigate([getUserHomePage(user)]);
    }
  }
}
